module.exports = __webpack_public_path__ + "img/pdf.04600c5c.png";